<template>
  <el-dialog
    title="鉴定能力配置"
    :visible.sync="visible"
    width="560px"
    append-to-body
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    @closed="handleClosed">
    <el-form
      ref="ruleForm"
      :model="ruleForm"
      :rules="rules"
      label-width="110px">
      <el-form-item
        label="鉴定师名称:"
        prop="staffName">{{ ruleForm.staffName }}</el-form-item>
      <el-form-item
        label="鉴定能力:"
        prop="categoryIds">
        <appraisal-abilities-select v-model="ruleForm.categoryIds" />
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button
        :loading="loading"
        @click="visible = false">取 消</el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSubmit">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import Online from '@/service/online'
import AppraisalAbilitiesSelect from './appraisal-abilities-select.vue'
export default {
  name: 'AppraisalAbilitiesModal',
  components: { AppraisalAbilitiesSelect },
  data() {
    return {
      loading: false,
      visible: false,
      ruleForm: { staffId: null, staffName: '', categoryIds: [] },
      rules: {
        categoryIds: [
          { required: true, message: '请选择鉴定能力', trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    handleClosed() {
      this.ruleForm = { ...this.ruleForm, ...this.$options.data().ruleForm }
      this.$nextTick(() => {
        this.$refs.ruleForm.clearValidate()
      })
    },
    handleSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true
          Online.setappraisalability({ ...this.ruleForm })
            .then(res => {
              this.loading = false
              const { result, message } = res.data
              if ([0].includes(result)) {
                this.loading = false
                this.visible = false
                this.$message.success('配置成功')
                this.$emit('fetch')
              } else {
                this.$message.error(message)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error(err.message)
            })
        }
      })
    },
    update(options = {}) {
      this.ruleForm = { ...this.ruleForm, ...options }
      this.visible = true
    }
  }
}
</script>
